export default {
  buttonType: '',
};
